import Axios from "axios";
import {
    SET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST,
    UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST,
} from "@/store/mutation-types";
import { 
    productionRequisitionResource,
} from "@/store/api";

const state = {
    getRawMetarialRequisitionList: [],
};

const getters = {
    getRawMetarialRequisitionList(state) {
        return state.getRawMetarialRequisitionList;
    },
};

const mutations = {
    [SET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST](state, data) {
        state.getRawMetarialRequisitionList = data;
    },
    [UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST](state) {
        state.getRawMetarialRequisitionList = [];
    },
};

const actions = {
    saveRawMetarialRequisition({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(productionRequisitionResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateRawMetarialRequisition({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${productionRequisitionResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getRawMetarialRequisitionList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(productionRequisitionResource)
            .then(function (response) {
            commit('SET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST');
            reject(error);
            });
        });
    },

    getProductionMaterialProducts({ commit }, search = "") {
        return Axios.get(`${productionRequisitionResource}/material-products`, { params: { search } })
            .then(response => response.data);
    },

    getProductionPackagingHistory({ commit }, productId) {
        return Axios.get(`${productionRequisitionResource}/packaging-history/${productId}`)
            .then(response => response.data);
    },

    getRawMetarialRequisitionById({ commit }, data) {
        const getTemplateRecordById = `${productionRequisitionResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getTemplateRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

